import { useMemo } from 'react';
import { SCHEMES } from '../styles/palette';
import useIsDark from './useIsDark';

// Resolved colours of the scheme on screen, for consumers that can't read CSS variables — Chart.js
// draws on a canvas, Recharts writes SVG attributes (DWLF-298). DOM styling uses var(--dwlf-*) instead.
// `ink(a)` is the text colour at alpha a, boosted like the --dwlf-ink-NN tokens on light.
export default function useSchemeColors() {
  const isDark = useIsDark();
  return useMemo(() => {
    const s = SCHEMES[isDark ? 'dark' : 'light'];
    const rgb = [1, 3, 5].map((i) => parseInt(s.text.slice(i, i + 2), 16)).join(', ');
    return { ...s, ink: (a) => `rgba(${rgb}, ${a >= 0.4 ? Math.min(1, a * s.boost) : a})` };
  }, [isDark]);
}
